module.exports = __webpack_public_path__ + "static/media/content-01.5ef7af93.png";